import merge from 'deepmerge'

const deepmerge = (obj1: any, obj2: any): any => {
  const overwriteMerge = (destinationArray: number[], sourceArray: number[]) =>
    sourceArray

  return merge(obj1, obj2, { arrayMerge: overwriteMerge })
}

export default deepmerge
